import {animate, AUTO_STYLE, state, style, transition, trigger} from '@angular/animations';

import {BBS_CATEGORY, VIDEO_CATEGORY} from './protocol';
import {CITY2, isRegion2, REGION, REGION2, REGION2_DEFAULT, SASEUNG} from './gukeo.const';
import {Word} from '../models/word.model';
import {SimpleDialect} from '../models/dialect.model';
import {SimpleWord} from '../models/simple-word.model';
import {Article} from '../models/article.model';
import {SimpleProverb} from '../models/proverb.model';
import {Saseung3} from '../models/saseung3.model';


export const APP_VERSION = '1.5.14.1';
export const APP_BUILD = '010051401';
export const APP_PLATFORM = "mweb";

/******************************************************************************
 * LocalStorage KEY
 *****************************************************************************/

export const LOCALSTORAGE_KEY_LIST_HELP = 'list-help';
export const LOCALSTORAGE_KEY_PITCH     = 'pitch';


/******************************************************************************
 * 링크 처리
 *****************************************************************************/

export enum LINK_TYPE {
  WORD,
  DIALECT,
}

export type LinkInfo2 = {
  type: LINK_TYPE;
  id: string;
};

//---- TODO: 위쪽은 삭제 예정

export type LinkInfo = {
  wordIds?: Array<string>;
  dialectIds?: Array<string>;
  dispTxt?: string;  // 화면에 표시된 형태
};


export enum RESULT_LINKPOPUP {
  POPUP_CLOSE,
  GOTO_LINK,
  GOTO_DETAIL,
};

export const LINK_POPUP_DELAY = 200;  // ms


export const LINK_POPUP_MEANING = 2; // 링크 팝업에 표시할 뜻의 갯수
export const WORD_LIST_MEANING = 2; // 단어 리스트에 표시할 뜻의 갯수

/******************************************************************************
 * 목록 화면에서 목록의 타입 - 라우팅 주소에 넣는 값
 *****************************************************************************/

export enum LIST_TYPE {
  SERVER = 's',
  BOOKMARK = 'b',
  HISTORY = 'h',
}

// export type ListType = LIST_TYPE.SERVER | LIST_TYPE.BOOKMARK | LIST_TYPE.HISTORY;


/******************************************************************************
 * 검색 이력에 관련된 수치
 *****************************************************************************/

export const HISTORY_PAGE_SIZE = 10;
export const HISTORY_LIST_MAX = 100;

export const LOCALSTORAGE_PREFIX_HISTORY = 'history-';
export const HISTORY_KEY_SEARCH_TOTAL = 'search-total';
export const HISTORY_KEY_SEARCH_WORD = 'search-word';
export const HISTORY_KEY_HISTORY_WORD = 'history-word';
export const HISTORY_KEY_SEARCH_SAJASEUNGEO = 'search-sajaseungeo';
export const HISTORY_KEY_SEARCH_HOMONYM = 'search-homonym';
export const HISTORY_KEY_SEARCH_PROVERB = 'search-proverb';
export const HISTORY_KEY_HISTORY_PROVERB = 'history-proverb';
export const HISTORY_KEY_SEARCH_DIALECT = 'search-dialect';
export const HISTORY_KEY_HISTORY_DIALECT = 'history-dialect';
export const HISTORY_KEY_SEARCH_SASEUNG = 'search-saseung';
export const HISTORY_KEY_HISTORY_SASEUNG = 'history-saseung';
export const HISTORY_KEY_SEARCH_VIDEO = 'search-video';
export const HISTORY_KEY_HISTORY_VIDEO = 'history-video';
export const HISTORY_KEY_SEARCH_BOARD = 'search-board';

export const HISTORY_KEY_SEARCH_EXAMPLE = "search-example";


/******************************************************************************
 * 보안 인증에 관련된 값
 *****************************************************************************/

export const LOCALSTORAGE_KEY_AUTH = 'auth';



/******************************************************************************
 * 소리 재생에 관련된 값
 *****************************************************************************/

export const PLAY_VOICE_DELAY = 300;  // ms - 소리 재생이 너무 빨라서 추가한 지연 시간.
export const WORD_VOICE_REPLAY_COUNT = 3;   // 단어 연속 재생 횟수 (TODO: 나중에 옵션으로 이동?)
export const VOICE_INTERVAL = 500;         // 연속 재생 시 소리간 간격, 1000 = 1초


/******************************************************************************
 * UI 처리
 *****************************************************************************/

export const WORD_HELP_POPUP_PADDING = 300;      // 단어 도움말 창 크기를 가변으로 조정하기 위함.
export const SASEUNG_HELP_POPUP_PADDING = 260;      // 사성 도움말 창에서 창 크기를 가변으로 조정하기 위함.


/******************************************************************************
 * InAppBrowser 옵션
 *****************************************************************************/

export const INAPPBROWSER_CLOSE_BUTTON_CAPTION = '닫기';
// export const INAPPBROWSER_TOOLBAR_COLOR = '#276757';
export const INAPPBROWSER_TOOLBAR_COLOR = '#000000';


export const UI_RELOAD_HEIGHT = 3000;          // 스크롤할 때, 화면이 리로드되는 높이
export const UI_RELOAD_HEIGHT_HOMONYM = 9000;          // 스크롤할 때, 화면이 리로드되는 높이

export const CONTAINER_SCROLL_DELAY = 300;     // 0.3 초 지연
export const LINK_POPUP_REOPEN_DELAY = 300;   // 팝업창이 다시 열려야 할 때, 대기 시간



export const LIST_SCROLL_INTERVAL = 100; // 스크롤 간격 (ms)
export const WORD_SCROLL_SPEED = 200; // 단어와 예문에서 리스트 스크롤 속도
export const HOMONYM_SCROLL_SPEED = 200; // 이운이의어 화면에서 스크롤 속도
export const DIALECT_SCROLL_SPEED = 250; // 지방어 리스트 스크롤 속도
export const PROVERB_SCROLL_SPEED = 200; // 속담 화면에서 리스트 스크롤 속도
export const SASEUNG_SCROLL_SPEED = 100; // 사성 옥편 화면에서 리스트 스크롤 속도
export const DEFAULT_SCROLL_SPEED = 50; // 기본 리스트 스크롤 속도



export const HOMONYM_BOX_PADDING = 18;             // 화면 padding 크기
export const HOMOYNM_BOX_MIN_PADDING = 5;
export const HOMONYM_BOX_TOLERANCE = HOMONYM_BOX_PADDING;  // 관용도, 이운이의어를 배치할 때 두개 열로 만들지 판단하는데 사용하는 상수
export const HOMONYM_BOX_MIN_PADDING_TOP = 5;
export const HOMONYM_BOX_MAX_PADDING_TOP = 40;
export const HOMONYM_REPOSITION_DELAY = 300;        // 목록이 로딩되고, 팝업창을 띄울 때까지의 지연 시간.


export const DETAIL_POPUP_DELAY = 200;        // 목록이 로딩되고, 팝업창을 띄울 때까지의 지연 시간.


// 속담 목록에서 속담 선택 시 스크롤 된다. 속담은 스크롤하면 선택이 풀리는데, 이것을 방지하기 위한 지연 시간.
export const PROVERB_SELECT_SCROLL_DELAY = 800;

export const WORD_DETAIL_HEIGHT_DELTA = 6; // 단어 상세 팝업의 위치 보정값
export const WORD_DETAIL_HEIGHT_DELTA_LARGE = 14; // 단어 상세 팝업의 위치 보정값
export const DIALECT_DETAIL_HEIGHT_DELTA = 6; // 사투리창 상세 팝업의 선택 항목 위치 보정값
export const DIALECT_DETAIL_ATTACH_DELTA = 10; // 사투리창 상세 팝업의 붙는 위치 보정값
export const DIALECT_TOTAL_HEIGHT_DELTA = 14; // 통합 검색 화면과, 링크 더보기 화면에서 사투리 부분의 보정값.
export const PROVERB_DETAIL_HEIGHT_DELTA = 6; // 속담 상세 팝업의 위치 보정값
export const EXAMPLE_DETAIL_HEIGHT_DELTA = 6; // 문장 듣기 상세 팝업의 위치 보정값
export const BOARD_SCROLL_OFFSETY = 6; // 사투리창 상세 팝업의 위치 보정값


export const SCROLL_DEBOUNCE_TIME = 1000; // (ms)
export const SCROLL_DEBOUNCE_TIME_HOMONYM = 2000; // (ms)
export const REPLACE_URL_AUDIT_TIME = 500; // (ms)


export const WORD_SELECT_ID = 'word_id_';
export function wordSelectId(word: SimpleWord): string {
  return WORD_SELECT_ID + word.id;
}

export const DIALECT_SELECT_ID = 'dialect_id_';
export function dialectSelectId(dialect: SimpleDialect): string {
  return DIALECT_SELECT_ID + dialect.id;
}

export const BOARD_SELECT_ID = 'board_id_';
export function boardSelectId(article: Article): string {
  return BOARD_SELECT_ID + article.no;
}

export const PROVERB_SELECT_ID = 'proverb_id_';
export function proverbSelectedId(proverb: SimpleProverb): string {
  return PROVERB_SELECT_ID + proverb.id;
}

export const SASEUNG_SELECT_ID = 'saseung_id_';
export function saseungSelectId(saseung: Saseung3): string {
  return SASEUNG_SELECT_ID + saseung.id;
}

/******************************************************************************
 * 옵션 처리에 관련된 값
 *****************************************************************************/

export const LOCALSTORAGE_KEY_OPTION = 'option';

export enum OPTION_TYPE {
  NONE,
  START_ANIM,
  AUTO_PLAY,
  LARGE_MODE,
  SHOW_SASEUNG,
  WORD_LEVEL,
  SEUNGJO_DISP,
  HOMONYM_DISP,
}

export enum SEUNGJO_DISP_TYPE {
  SYMBOL,
  NUMBER,
  COLOR,
}

export enum HOMONYM_DISP_TYPE {
  BASIC,
  SIMPLE,
}


export type License = {
  name: string;
  version?: string;
  licenses: string;
  repository?: string;
  publisher?: string;
  email?: string;
  url?: string;
  licenseFile?: string;
  licenseUrl?: string;
};


/******************************************************************************
 * 게시판 UI 관련
 *****************************************************************************/

// BBS_CATEGORY와 순서가 일치해야 한다.
export const BBS_INFO: Array<{
  placeholder: string | null;
}> = [
  {
    placeholder: null,
  },
  {
    placeholder: '운영자의 말',
  },
  {
    placeholder: '베풀기',
  },
];

/******************************************************************************
 * 동영상 처리 관련
 *****************************************************************************/

export type VideoQueryParams = {
  l: LIST_TYPE;
  cat: VIDEO_CATEGORY;
};

export type VIDEO_CATEGORY_DATA = {
  category: VIDEO_CATEGORY;
  name: string;
  cssIdx: number;
  routerLink?: string[];
  queryParams?: VideoQueryParams;
};


/**
 * 영상 범주 목록
 * TODO: 영상 범주가 급격히 바뀐다면, 범주 정보도 서버에서 받아오도록 수정할 필요가 있다.
 */
export const VIDEO_DATA_LIST: Array<VIDEO_CATEGORY_DATA> = [
  {
    category: VIDEO_CATEGORY.DIALECT,
    name: '모두 우리말',
    cssIdx: 1,
    routerLink: ['/dialect-movie'],
  },
  {
    category: VIDEO_CATEGORY.COOL_EXPR,
    name: '멋지게 말하기',
    cssIdx: 3,
    routerLink: ['/movie-search'],
    queryParams: {
      l: LIST_TYPE.SERVER,
      cat: VIDEO_CATEGORY.COOL_EXPR,
    },
  },
  {
    category: VIDEO_CATEGORY.WRONG_EXPR,
    name: '잘못된 표현',
    cssIdx: 2,
    routerLink: ['/movie-search'],
    queryParams: {
      l: LIST_TYPE.SERVER,
      cat: VIDEO_CATEGORY.WRONG_EXPR,
    },
  },
  {
    category: VIDEO_CATEGORY.PROVERB,
    name: '속담',
    cssIdx: 1,
    routerLink: ['/movie-search'],
    queryParams: {
      l: LIST_TYPE.SERVER,
      cat: VIDEO_CATEGORY.PROVERB,
    },
  },
  {
    category: VIDEO_CATEGORY.LOAN_WORD,
    name: '외래어',
    cssIdx: 3,
    routerLink: ['/movie-search'],
    queryParams: {
      l: LIST_TYPE.SERVER,
      cat: VIDEO_CATEGORY.LOAN_WORD,
    },
  },
  {
    category: VIDEO_CATEGORY.HOMONYM,
    name: '같은 글자, 다른 소리',
    cssIdx: 2,
    routerLink: ['/movie-search'],
    queryParams: {
      l: LIST_TYPE.SERVER,
      cat: VIDEO_CATEGORY.HOMONYM,
    },
  },
];

export function findVideoData(category: VIDEO_CATEGORY): VIDEO_CATEGORY_DATA | undefined {
  return VIDEO_DATA_LIST.find(item => item.category === category);
}



/******************************************************************************
 * 화면에 단어와 성조, 장단기호, 한사, 사성을 표현하기위한 구조체
 *****************************************************************************/

export enum CHAR_TYPE {
  HANGUL,
  HANJA,
  JANGDAN,
}

export type CHAR_STRUCT = {
  char: string;

  type: CHAR_TYPE;
  seungjo?: number;
  seungjo2?: number;    // 허용되는 성조

  saseung?: SASEUNG;
  firstHanja?: boolean; // 할글 뒤에 처음 나오는 한자 (공간을 띄우기 위해서)
};

export type WORD_STRUCT = Array<CHAR_STRUCT>;

/*****************************************************************************
 * TODO: SearchParam 를 라우트 파라미터와 API 파라미터 양쪽에 사용하는 것이 문제임. 두개를 분리해야 함.
 */
export interface SearchParam {
  l?: LIST_TYPE;  // 목록의 타입 (주소에서 빼서 이리로 옮김)
  index?: string;
  keyword?: string;
  level?: number;
  limit?: number;
  id?: string;
  start?: string;
  serial?: number;  // 링크 처리에서 페이지를 강제적으로 재로딩하는데 사용.

  cat?: VIDEO_CATEGORY;  // video 에서만 사용
  story?: number | 'all';     // video 에서만 사용 (같은 이야기를 지역별로 다르게 표현할 때)
  city?: CITY2;       // video 에서만 사용
  // region?: string;    // dialect 에서 지역 지도 확대에 사용함.
  region2?: string;    // dialect 에서만 사용
  map?: string;       // dialect 에서만 사용
  bbs_cat?: BBS_CATEGORY; // board 에서만 사용
  saja?: number;      // sajaseungeo 에서만 사용. 1 = 사 자 성어 검색 시 필터값
  hangul?: string;    // saseung-hanja 에서만 사용
  hanja?: string;    // saseung-hanja 에서만 사용

  postposition?: number; // example 에서만 사용 (조사 ID 필터)
  pp?: number;           // example URL용 (postposition의 단축명)
  example_cat?: number;  // example URL용 (범주 ID)

  wid?: string;        // word_id 와 같은 의미, 통합검색 (total, link에서만 사용)
  did?: string;        // dialect_id 와 같은 의미, 통합검색 (total, link에서만 사용)
  eid?: string;         // example_id와 같은 의미, 통합검색 (total에서만 사용)
  pid?: string;         // proverb_id와 같은 의미, 통합검색 (total에서만 사용)
  sid?: string;         // saseung_id와 같은 의미, 통합검색 (total에서만 사용)

  wids?: string;       // 표시해야 할 단어 id목록, "," 으로 id들을 구분 (link에서만 사용)
  dids?: string;       // 표시해야 할 사투리 id목록, "," 으로 id들을 구분 (link에서만 사용)

  hun?: string;       // 훈 더보기 api에서 사용
}

export type WORD_PAGE_RESULT = {
  listWord: Array<Word>;    // 현재 받아온 단어 목록
  count: number;            // 전체 단어의 수
};


/******************************************************************************
 * 지역 정보
 *****************************************************************************/

export type REGION_INFO = {
  region: REGION,
  text: string,
  txt: string,
  css: number,
  select: number;
  pos: { top: number, left: number } | null;    // TODO: 사용처 없음 — 삭제 필요
  pos2: { top: number, left: number } | null;   // dialect-map 컴포넌트(다른 지역, 같은 말 팝업)의 권역 라벨 위치
  pos3: { top: number, left: number } | null;   // region-select-all 컴포넌트(전체 지도 / 지역 선택 화면)의 말풍선 위치
  coords: Array<number>,  // img map 좌표
};


/**
 * WARN: enum REGION 와 순서가 일치해야 한다.
 */
export const REGION_LIST: Array<REGION_INFO> = [
  {
    region: REGION.ALL,
    text: '전국',
    txt: '전국',
    css: 0,
    select: null,
    pos: null,
    pos2: null,
    pos3: null,
    coords: null,
  },
  {
    region: REGION.GANGWON,
    text: '강원도',
    txt: '강원',
    css: 1,
    select: 1,
    pos: { top: 21, left: 56 },
    pos2: { top: 26, left: 61 },
    pos3: { top: 22, left: 62 },
    coords: [529, 146, 488, 211, 288, 217, 385, 311, 369, 376, 422, 398, 405, 493, 486, 477, 600, 526, 714, 498, 713, 499],
  },
  {
    region: REGION.GYEONGSANG,
    text: '경상도',
    txt: '경상',
    css: 2,
    select: 2,
    pos: { top: 50, left: 58 },
    pos2: { top: 56, left: 66 },
    pos3: { top: 50, left: 70 },
    coords: [712, 498, 596, 519, 568, 513, 531, 576, 497, 560, 426, 610, 423, 695, 461, 707, 370, 856, 384, 895, 366, 921, 414, 1065, 580, 1062, 686, 947, 755, 745, 712, 696, 733, 583],
  },
  {
    region: REGION.JEONLA,
    text: '전라도',
    txt: '전라',
    css: 3,
    select: 3,
    pos: { top: 60, left: 20 },
    pos2: { top: 66, left: 28 },
    pos3: { top: 60, left: 32 },
    coords: [198, 761, 45, 1046, 89, 1142, 278, 1154, 431, 1109, 371, 921, 391, 889, 374, 853, 440, 771, 425, 751, 347, 756, 328, 728, 253, 725],
  },
  {
    region: REGION.JEJU,
    text: '제주도',
    txt: '제주',
    css: 4,
    select: 4,
    pos: { top: 87, left: 20 },
    pos2: { top: 88, left: 21 },
    pos3: { top: 82, left: 25 },
    coords: [293, 1194, 180, 1205, 126, 1242, 121, 1280, 155, 1291, 243, 1286, 319, 1243],
  },
  {
    region: REGION.CHUNGCHEONG,
    text: '충청도',
    txt: '충청',
    css: 5,
    select: 5,
    pos: { top: 41, left: 21 },
    pos2: { top: 45, left: 33 },
    pos3: { top: 42, left: 37 },
    coords: [172, 512, 103, 573, 204, 763, 260, 728, 363, 765, 433, 754, 463, 707, 427, 687, 434, 607, 501, 562, 533, 579, 570, 511, 483, 475, 404, 491, 322, 548, 291, 532, 233, 544],
  },
];

export const DEFAULT_REGION_CSS = 1;

export function GetRegionByEnum(region: REGION): REGION_INFO|null {
  return (0 <= region && region < REGION.MAX) ? REGION_LIST[region] : null;
}

export function GetRegionText(region: REGION): string | null {
  const regionInfo = GetRegionByEnum(region);
  return regionInfo ? regionInfo.text : null;
}

export function GetRegionTxt(region: REGION): string | null {
  const regionInfo = GetRegionByEnum(region);
  return regionInfo ? regionInfo.txt : null;
}

export function GetRegionByText(text: string): REGION_INFO | null {
  const idx = REGION_LIST.findIndex(value => value.text === text);
  return idx === -1 ? null : REGION_LIST[idx];
}

export function GetRegionByTxt(text: string): REGION_INFO | null {
  const idx = REGION_LIST.findIndex(value => value.txt === text);
  return idx === -1 ? null : REGION_LIST[idx];
}

export function GetRegionCoordsTxt(regionInfo: REGION_INFO, ratio: number): string {
  let coords: string = null;
  regionInfo.coords.forEach(value => {
    const coord = (value * ratio).toFixed(1);
    if (coords) {
      coords += ',' + coord;
    }
    else {
      coords = String(coord);
    }
  });
  return coords;
}


/**
 * 코드는 문자화 작업자가 만든 코드. css를 수정하지 않고, 해당 번호를 찾는 함수로 만듬.
 */
export function cssRegionCodeTxt(regionText: string): number {
  const regionInfo = GetRegionByText(regionText);
  return regionInfo ? regionInfo.css : 0;
}

export function cssRegionCode(region: REGION): number {
  return REGION.ALL < region && region < REGION.MAX ? REGION_LIST[region].css : 0;
}

/************************************************************
 * 지역 정보 버전2
 */

export const CSS_REGION_ALL = '0';
export const CSS_REGION_GANGWON = '1';
export const CSS_REGION_GYEONGSANG = '2';
export const CSS_REGION_JEONLA = '3';
export const CSS_REGION_JEJU = '4';
export const CSS_REGION_CHUNGCHEONG = '5';



export type REGION_INFO2 = {
  region2: REGION2;
  region: REGION;
  css: string;
  cssPos: string; // 위치 지정용 CSS
  name: string;
};

export const REGION_INFO2_LIST: Array<REGION_INFO2> = [
  { region2: '강원', cssPos: '1', region: REGION.GANGWON, css: CSS_REGION_GANGWON, name: '강원도' },
  { region2: '경남', cssPos: '3', region: REGION.GYEONGSANG, css: CSS_REGION_GYEONGSANG, name: '경상남도' },
  { region2: '경북', cssPos: '2', region: REGION.GYEONGSANG, css: CSS_REGION_GYEONGSANG, name: '경상북도' },
  { region2: '전남', cssPos: '5', region: REGION.JEONLA, css: CSS_REGION_JEONLA, name: '전라남도' },
  { region2: '전북', cssPos: '4', region: REGION.JEONLA, css: CSS_REGION_JEONLA, name: '전라북도' },
  { region2: '제주', cssPos: '6', region: REGION.JEJU, css: CSS_REGION_JEJU, name: '제주도' },
  { region2: '충남', cssPos: '8', region: REGION.CHUNGCHEONG, css: CSS_REGION_CHUNGCHEONG, name: '충청남도' },
  { region2: '충북', cssPos: '7', region: REGION.CHUNGCHEONG, css: CSS_REGION_CHUNGCHEONG, name: '충청북도' },
  { region2: '전국', cssPos: '0', region: REGION.ALL, css: CSS_REGION_ALL, name: '전全 지역' },
];

export const REGION_INFO2_MAP: Map<REGION2, REGION_INFO2> = new Map(
  REGION_INFO2_LIST.map(item => [item.region2, item])
);


export function GetRegion2Css(region2: string): string {
  const validRegion2 = isRegion2(region2) ? region2 : REGION2_DEFAULT;
  return REGION_INFO2_MAP.get(validRegion2)?.css ?? '0';
}


export function GetRegion2CssPos(region2: string): string {
  const validRegion2 = isRegion2(region2) ? region2 : REGION2_DEFAULT;
  return REGION_INFO2_MAP.get(validRegion2)?.cssPos ?? '0';
}


export function GetRegion2Name(region2: string): string {
  const validRegion2 = isRegion2(region2) ? region2 : REGION2_DEFAULT;
  return REGION_INFO2_MAP.get(validRegion2)?.name ?? '전全 지역';
}

export function GetRegionFromRegion2(region2: REGION2 | null): REGION {
  const validRegion2 = isRegion2(region2) ? region2 : REGION2_DEFAULT;
  const regionInfo = REGION_INFO2_MAP.get(validRegion2);
  return regionInfo ? regionInfo.region : REGION.ALL;
}

export function GetRegionTxtFromRegion2(region2: REGION2 | null): string {
  const validRegion2 = isRegion2(region2) ? region2 : REGION2_DEFAULT;
  const regionInfo = REGION_INFO2_MAP.get(validRegion2);
  return regionInfo ? GetRegionTxt(regionInfo.region) : '전국';
}


/************************************************************
 *
 */

export type CITY2_INFO = {
  city2: CITY2;
  css: string;  // color 지정용
  cssPos: string; // 도시 위치 지정용
  region: REGION;
  region2: REGION2;
  display: string;
  listTxt: string;  // 목록에 표시
};

export const CITY2_INFO_LIST: Array<CITY2_INFO> = [
  {
    city2: '강릉',
    cssPos: '1',
    css: CSS_REGION_GANGWON,
    region: REGION.GANGWON,
    region2: '강원',
    display: '강릉',
    listTxt: '강원도 강릉',
  },
  {
    city2: '대구',
    cssPos: '2',
    css: CSS_REGION_GYEONGSANG,
    region: REGION.GYEONGSANG,
    region2: '경북',
    display: '대구',
    listTxt: '경상도 대구',
  },
  {
    city2: '부산',
    cssPos: '3',
    css: CSS_REGION_GYEONGSANG,
    region: REGION.GYEONGSANG,
    region2: '경남',
    display: '부산',
    listTxt: '경상도 부산',
  },
  {
    city2: '포항',
    cssPos: '4',
    css: CSS_REGION_GYEONGSANG,
    region: REGION.GYEONGSANG,
    region2: '경북',
    display: '포항',
    listTxt: '경상도 포항',
  },
  {
    city2: '하동',
    cssPos: '5',
    css: CSS_REGION_GYEONGSANG,
    region: REGION.GYEONGSANG,
    region2: '경남',
    display: '하동',
    listTxt: '경상도 하동',
  },
  {
    city2: '광주',
    cssPos: '6',
    css: CSS_REGION_JEONLA,
    region: REGION.JEONLA,
    region2: '전남',
    display: '광주',
    listTxt: '전라도 광주',
  },
  {
    city2: '전주',
    cssPos: '7',
    css: CSS_REGION_JEONLA,
    region: REGION.JEONLA,
    region2: '전북',
    display: '전주',
    listTxt: '전라도 전주',
  },
  {
    city2: '대전',
    cssPos: '8',
    css: CSS_REGION_CHUNGCHEONG,
    region: REGION.CHUNGCHEONG,
    region2: '충남',
    display: '대전',
    listTxt: '충청도 대전',
  },
  {
    city2: '서산',
    cssPos: '9',
    css: CSS_REGION_CHUNGCHEONG,
    region: REGION.CHUNGCHEONG,
    region2: '충남',
    display: '서산',
    listTxt: '충청도 서산',
  },
  {
    city2: '제천',
    cssPos: '10',
    css: CSS_REGION_CHUNGCHEONG,
    region: REGION.CHUNGCHEONG,
    region2: '충북',
    display: '제천',
    listTxt: '충청도 제천',
  },
  {
    city2: '전국',
    cssPos: '0',
    css: CSS_REGION_ALL,
    region: REGION.ALL,
    region2: '전국',
    display: '전全&nbsp;지역',
    listTxt: '전全&nbsp;지역',
  },
];

export const CITY2_INFO_MAP: Map<CITY2, CITY2_INFO> = new Map(
  CITY2_INFO_LIST.map(item => [item.city2, item])
);

export function GetCity2Css(city2: string): string {
  return CITY2_INFO_MAP.get(city2 as CITY2)?.css ?? '0';
}

export function GetCity2Css2(city2: string): string {
  return CITY2_INFO_MAP.get(city2 as CITY2)?.cssPos ?? '0';
}

export function GetCity2DisplayTxt(city2: string): string {
  return CITY2_INFO_MAP.get(city2 as CITY2)?.display ?? '전全&nbsp;지역';
}



/******************************************************************************
 * 곰돌이 애니메이션 처리 관련
 *****************************************************************************/

export enum BEAR_ANIM {
  NORMAL,
  BLINK,
  SPEAK,
  EAR,
}

export const BEAR_BLINK_DELAY = 1.5 * 1000;  // 눈 깜빡이는 시간 (눈 깜빡이는 애니메니셩 2초, 조금 일찍 끊나게 함.)
export const BEAR_BLINK_DURATION = 1 * 1000;  // 눈 깜빡임 사이의 대기 시간: 1초

/******************************************************************************
 * Angular Component 애니메이션 정의
 *****************************************************************************/

export const triggerDetailPopup = trigger('wordDetailInOut', [
  transition(':enter', [
    style({transform: 'translateY(100%)'}),
    animate('100ms ease-in', style({transform: 'translateY(0%)'}))
  ]),
  transition(':leave', [
    animate('100ms ease-in', style({transform: 'translateY(50%)'}))
  ])
]);


const DEFAULT_DURATION = 200; // ms

export const triggerCollapse = trigger('collapse', [
  state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
  state('true', style({ height: '0', visibility: 'hidden' })),
  transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
  transition('true => false', animate(DEFAULT_DURATION + 'ms ease-in')),
  transition(':enter', [
    style({ height: '0', visibility: 'hidden' }),
    animate(DEFAULT_DURATION + 'ms ease-in', style({ height: AUTO_STYLE, visibility: AUTO_STYLE }))
  ]),
  transition(':leave', [
    style({ height: AUTO_STYLE, visibility: AUTO_STYLE }),
    animate(DEFAULT_DURATION + 'ms ease-in', style({ height: '0', visibility: 'hidden' }))
  ])
]);


export const expandCollapse = trigger('expandCollapse', [
  transition(':enter', [
    style({ height: '0', overflow: 'hidden' }), // 초기 상태
    animate('300ms ease-in', style({ height: '*', overflow: 'hidden' })) // 최종 상태
  ]),
  transition(':leave', [
    style({ height: '*', overflow: 'hidden' }), // 초기 상태
    animate('300ms ease-in', style({ height: '0', overflow: 'hidden' })) // 최종 상태
  ])
]);


export const fadeInOut = trigger('fadeInOut', [
  // :enter는 void => * 전환과 동일합니다 (요소가 DOM에 삽입될 때)
  transition(':enter', [
    style({ opacity: 0 }), // 애니메이션 시작 상태를 설정합니다 (투명도 0)
    animate('200ms', style({ opacity: 1 })) // 200ms 동안 투명도를 1까지 부드럽게 전환합니다
  ]),
  // :leave는 * => void 전환과 동일합니다 (요소가 DOM에서 삭제될 때)
  transition(':leave', [
    style({ opacity: 1 }), // 애니메이션 시작 상태를 설정합니다 (투명도 1)
    animate('200ms', style({ opacity: 0 })) // 200ms 동안 투명도를 0까지 부드럽게 전환합니다
  ])
]);


export const triggerNotiPopup = trigger('notiPopupInOut', [
  transition(':enter', [
    style({transform: 'translateY(-100%)'}),
    animate('100ms ease-in', style({transform: 'translateY(0%)'}))
  ]),
  transition(':leave', [
    animate('100ms ease-in', style({transform: 'translateY(-100%)'}))
  ])
]);
